import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import NotificationService from "services/NotificationService";

let initialState = { list: [] };

export const getNotifications = createAsyncThunk(
  "userNotification/getNotifications",
  async () => {
    const response = await NotificationService.getNotifications();
    return response?.results;
  }
);

export const readNotifications = createAsyncThunk(
  "userNotification/readNotifications",
  async (body) => {
    const response = await NotificationService.readNotifications(body);
    return response?.results;
  }
);

export const trashNotifications = createAsyncThunk(
  "userNotification/trashNotifications",
  async (body) => {
    const response = await NotificationService.trashNotifications(body);
    return response?.results;
  }
);

const userNotificationSlice = createSlice({
  name: "userNotification",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getNotifications, builder, ["list"]);
  },
});

export default userNotificationSlice.reducer;

export const selectUnReadNotification = (state) =>
  state.userNotification.list.filter((x) => !x.isRead);
